const createAccountTexts = {
  alreadyHaveAccount: "Já possui uma conta? ",
  enterNowButton: "Entre agora.",
};

export default createAccountTexts;
